export const SHORT_ITALIAN_FORMAT = 'dd/MM/yyyy';
export const LONG_ITALIAN_FORMAT = 'dd/MM/yyyy HH:mm';
export const SHORT_ITALIAN_ALT_FORMAT = 'dd-MM-yyyy';
